/* eslint-disable no-prototype-builtins */
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';

import { environment } from 'src/environments/environment';
import { EventData } from '../model/api/data-rest';
import { AppState } from '../store/app.reducer';
import * as DeviceThActions from 'src/app/store/device-th/device-th.actions';

@Injectable({
	providedIn: 'root'
})
export class WebsocketThermoService {
	socketSub: Subscription;
	socket$: WebSocketSubject<EventData>;

	keycode: string;

	constructor(
		private store: Store<AppState>,
	) { }

	closeWebSocket(): void {
		console.log('CLOSE WEBSOCKET THERMO');
		this.socketSub?.unsubscribe();
	}

	openWebSocket(token: string, keycode: string, devcode: string, userId?: number): void {
		console.log('OPEN WEBSOCKET THERMO');
		this.keycode = keycode;
		this.newWebsocket(token, keycode, devcode);
		this.socketSub = this.socket$.pipe(filter(m => !!m)).subscribe(message => {
			this.dispatchMessage(message, userId);
		});

		setInterval(() => {
			const message: EventData = { Success: true };
			this.socket$.next(message);
		}, 30000);
	}

	newWebsocket(token: string, keycode: string, devcode: string): void {
		const url = environment.websocketUrlThermo + '/' + keycode + '/' + devcode;
		this.socket$ = webSocket({
			url,
			protocol: ['bearer', token],
		});
	}

	dispatchMessage(wsMessage: EventData, userId?: number): void {
		if (wsMessage.hasOwnProperty('on_line') || wsMessage.hasOwnProperty('manual_temp') || wsMessage.hasOwnProperty('mode') || wsMessage.hasOwnProperty('temp_loc') ||
			wsMessage.hasOwnProperty('manual_temp') || wsMessage.hasOwnProperty('current_season') ||
			wsMessage.hasOwnProperty('relay_status') || wsMessage.hasOwnProperty('bb.enable') || wsMessage.hasOwnProperty('bb.temp') ||
			wsMessage.hasOwnProperty('bb.delta_temp_n') || wsMessage.hasOwnProperty('bb.delta_temp_p') || wsMessage.hasOwnProperty('qe.enable') ||
			wsMessage.hasOwnProperty('qe.stdby_temp') || wsMessage.hasOwnProperty('qe.courtesy_time') || wsMessage.hasOwnProperty('qe.permission_status')) {
			if (userId !== null && userId !== undefined) {
				this.store.dispatch(DeviceThActions.getThermoDeviceV2({ keycode: this.keycode, userId: userId }));
			} else {
				this.store.dispatch(DeviceThActions.getThermoDeviceV2({ keycode: this.keycode }));
			}
		}
	}

}
